<template>
  <div :class="className" :id="id" :style="{ height: height, width: width }" />
</template>

<script>
export default {
  name: "JiaotongFangshi",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "210px"
    },
    chartData: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    if (this.chartData) {
      this.initChart();
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    chartData() {
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.initChart();
    }
  },
  methods: {
    initChart() {
      var option = {
        grid: {
          top: 10,
          bottom: 10,
          containLabel: true
        },
        xAxis: {
          type: "value",
          max: 100,
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#414f5a",
              type: "dashed"
            }
          },
          axisLabel: {
            textStyle: {
              color: "#fff"
            },
            formatter: function(value) {
              return value + "%";
            }
          }
        },
        yAxis: {
          type: "category",
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#fff"
            }
          },
          data: this.chartData.nameList
        },
        series: [
          {
            data: this.chartData.data,
            type: "bar",
            barWidth: 14,
            itemStyle: {
              normal: {
                //每根柱子颜色设置
                color: function(params) {
                  let colorList = ["#1d89ff", "#00cdff", "#4be8ca", "#eecf50"];
                  return colorList[params.dataIndex];
                },
                label: {
                  color: "#fff",
                  show: true,
                  position: "right",
                  formatter: function(params) {
                    return (
                      params.value + "%   {img" + (params.dataIndex + 1) + "|}"
                    );
                  },
                  rich: {
                    img1: {
                      width: 70,
                      height: 30,
                      backgroundColor: {
                        image: "/img/bus.png"
                      }
                    },
                    img2: {
                      width: 70,
                      height: 30,
                      backgroundColor: {
                        image: "/img/train.png"
                      }
                    },
                    img3: {
                      width: 70,
                      height: 30,
                      backgroundColor: {
                        image: "/img/high_speed.png"
                      }
                    },
                    img4: {
                      width: 70,
                      height: 30,
                      backgroundColor: {
                        image: "/img/plane.png"
                      }
                    }
                  }
                }
              }
            }
          }
        ]
      };

      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption(option);
    }
  }
};
</script>
<style scoped lang="less">
.chart {
  width: 100% !important;
  height: 100% !important;
}
</style>
